<template>
  <div v-if="tesEmployee" class="details-wrapper">
    <div class="details-header">
      <div>TES Employee #{{ tesEmployee.reference_number }}</div>
    </div>
    <div v-if="tesEmployee.reference_number" class="details-body">
      <tol-sidebar :menu-items="sidebarMenu" />
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <section class="details-section">
            <TesEmployeeDetailsForm :tes-employee="tesEmployee" />
          </section>
          <section class="details-section">
            <h1>{{ $t('tesEmployees.labels.attachment') }}</h1>
            Tes Employee Attachment is not implemented yet
          </section>
          <section class="details-section">
            <h1>{{ $t('tesEmployees.labels.history') }}</h1>
            Tes Employee history is not implemented yet
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppActions } from '@/app/app.keys';
import TolSidebar from '@/app/components/TolSidebar';
import { TesEmployeeDetailsActions, TesEmployeeDetailsGetters } from './tes-employee-details.keys';
import TesEmployeeDetailsForm from './components/TesEmployeeDetailsForm';

export default {
  name: 'TesEmployeesDetails',
  components: { TolSidebar, TesEmployeeDetailsForm },

  data() {
    return {
      sidebarMenu: [
        {
          label: this.$t('tesEmployees.labels.personalDetails'),
          submenu: [{ label: this.$t('tesEmployees.labels.commissionProfiles') }]
        },
        { label: this.$t('tesEmployees.labels.attachments') },
        { label: this.$t('tesEmployees.labels.history') }
      ]
    };
  },
  computed: {
    tesEmployee: {
      get() {
        return this.$store.getters[TesEmployeeDetailsGetters.CurrentTesEmployee];
      }
    }
  },
  destroyed() {
    this.$store.dispatch(TesEmployeeDetailsActions.ResetCurrentTesEmployee);
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('tesEmployees.details.title'));
    this.$store.dispatch(
      TesEmployeeDetailsActions.RetrieveTesEmployee,
      this.$route.params.reference_number
    );
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;
  .details-header {
    display: flex;

    padding: $details-padding;
    border-bottom: 2px solid $row-border;
    justify-content: space-between;
  }

  .details-body {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }

    .details-section {
      padding-bottom: 25px;

      h1 {
        border-bottom: 1px solid $row-border;
      }
    }
  }
}
</style>
